export default "__VITE_ASSET__lM8sZDrs__"